import { useNavigate } from 'react-router';
import {AccessBtnComponent} from '../Components/access-btn.component';
import {Helmet} from '@dr.pogodin/react-helmet';

const NotFoundPage = () => {
    const navigate = useNavigate();
    return (
        <>
            <Helmet>
                <title>404 Not Found - Lesia K Slot 2D Art Development</title>
                <link rel="canonical" href={`https://lesia-k.com/404`}/>

                <meta name="description"
                      content="The page you are looking for does not exist. Return to the homepage of Lesia K Slot 2D Art Development."/>
                <meta name="keywords"
                      content="404, not found, page missing, Lesia K, slot 2D art development"/>
                <meta property="og:title" content="404 Not Found - Lesia K Slot 2D Art Development"/>
                <meta property="og:description"
                      content="The page you are looking for does not exist. Return to the homepage of Lesia K Slot 2D Art Development."/>
                <meta property="og:url" content="https://lesia-k.com/404"/>
                <meta name="twitter:title" content="404 Not Found - Lesia K Slot 2D Art Development"/>
                <meta name="twitter:description"
                      content="The page you are looking for does not exist. Return to the homepage of Lesia K Slot 2D Art Development."/>
            </Helmet>
            <section className="w-screen h-screen">
                <div className="flex flex-col items-center justify-center h-full">
                    <img alt={"not found"} src="https://storage.googleapis.com/lesia-k/Pictures/DogUfo.png"
                         className="h-[30rem]"/>
                    <h1 className="text-5xl font-boldonse text-center text-white">404</h1>
                    <h2 className="text-3xl font-boldonse text-center text-white">Page not found</h2>
                    <AccessBtnComponent text="Go home" onClick={() => navigate('/')}/>
                </div>
            </section>
        </>
    )
}

export default NotFoundPage;
